module.exports = __webpack_public_path__ + "static/media/stm_rw2.438eed96.pdf";